import { Component, OnInit } from '@angular/core';
import { FileStatusService } from '../service/file-status.service';
import { FileStatusModel } from '../model/file-status.model';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'app-file-status',
  templateUrl: './file-status.component.html',
  styleUrls: ['./file-status.component.css']
})
export class FileStatusComponent implements OnInit {

  fileModel: FileStatusModel = new FileStatusModel("", null, null, null, null, null);
  resultTable: any[] = null;
  cols: any[];
  msgs: Message[] = [];
  from: Date;
  to: Date;
  dateOptionListDDL: any[];
  dateOptionSelected: any;

  constructor(private dataService: FileStatusService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    this.from = new Date();
    this.to = new Date();
    

    this.userService.getUserClaims().subscribe((result: any) => {
      if (result.Roles[0]) {
        this.fileModel.Role = result.Roles[0];
      }
      else {
        return this.showMessage('error', '', 'תקלה בקבלת הרשאות ');
      }
    },
      (err: HttpErrorResponse) => {
        this.fileModel.Role = "";
        this.showMessage('error', '', 'תקלה בקבלת רשימת הרשאות ');
      });

    // this.dataService.getRole().subscribe((result: any) => {
    //   this.fileModel.Role = result;
    // }, (err: HttpErrorResponse) => {
    //   this.showMessage('error', '', 'תקלה בקבלת רשימת הרשאות ');
    // });

    this.dataService.getCustomerDDL().subscribe((res: any) => {
      this.fileModel.customerListDDL = res;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
    });

    this.fileModel.statusListDDL = [
      { label: 'הכל', value: null },
      { label: 'לא תקינים בלבד', value: 1 },
      { label: 'תקינים בלבד', value: 2 },
      { label: 'חדש', value: 3 }
    ];

    this.dateOptionListDDL = [
      {label: 'שלושה חודשים אחרונים', value: 3},
      {label: 'ששה חודשים אחרונים', value: 6},
      {label: 'טווח תאריכים', value: 0}
    ];
    this.dateOptionSelected = 3;

    this.cols = [
      { field: 'FileName', header: 'שם קובץ', invisible: false },
      { field: 'CustomerName', header: 'מעסיק', invisible: false },
      { field: 'ExecutionDate', header: 'תאריך הגשה', invisible: false },
      { field: 'StatusName', header: 'סטטוס', invisible: false },
      { field: 'Result_Date', header: 'תאריך סטטוס', invisible: false },
      { field: 'ErrorFileLevel', header: 'שגיאה ברמת קובץ', invisible: true },
      { field: 'ErrorsRowLevel', header: 'שגיאה ברמת רשומה', invisible: true },
    ];
  }

  getReport(): void {
    let sFrom: string = "";
    let sTo: string = "";
    if ((this.from != null || this.from != undefined) && (this.to != null || this.to != undefined) && this.to < this.from) {
      return this.showMessage('error', '', 'תאריך אינו חוקי. מתאריך לא יכול להיות קטן מעד תאריך');
    }
    this.fileModel.selectOptionDDL = this.fileModel.selectOptionDDL == null ? "" : this.fileModel.selectOptionDDL;
    sFrom = (this.from != null || this.from != undefined) ? new Date(this.from).toDateString() : '';
    sTo = (this.to != null || this.to != undefined) ? new Date(this.to).toDateString() : '';

    this.dataService.getReport(this.fileModel.selectStatusDDL, this.fileModel.selectOptionDDL, sFrom, sTo, this.dateOptionSelected).subscribe((result: any) => {
      this.resultTable = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת דוח ');
    });
  }

  setStatus(num: number): void {
    let c = confirm('האם ברצונך לקבוע תקינות קובץ?');
    if (c) {
      this.dataService.setStatus(num).subscribe((result: any) => {
        if (result === 'Success') {
          this.showMessage('success', '', 'כקבע כתקין נשמר בהצלחה');
          this.getReport();
        }
        else {
          this.showMessage('error', '', 'קיימת תקלה בשמירה');
        }
      }, (err: HttpErrorResponse) => {
        //this.router.navigate(['error-page/', err.error.ExceptionMessage]);
        this.showMessage('error', '', 'תקלה בשמירה');
      });
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  // downloadFile(fileName: string): void {
  //   if (fileName) {
  //     this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
  //     this.dataService.getDownloadFile(fileName).subscribe((result: any) => {
  //       window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
  //       let url = window.URL.createObjectURL(result)
  //       const openFile = document.createElement('a');
  //       openFile.href = url;
  //       openFile.download = `${fileName}`;
  //       openFile.click();
  //       setTimeout(() => {
  //         this.showMessage('success', '', 'הקובץ נשמר בהצלחה');
  //       }, 1000);
  //     }, (err: HttpErrorResponse) => {
  //       this.showMessage('error', '', 'תקלה בהורדת הקובץ');
  //     });
  //   } else {
  //     this.showMessage('error', '', 'לא נבחר קובץ');
  //   }
  // }


  downloadFile(fileName: string, MISPAR_ZIHUY_MAASIK: string): void {
    if (fileName) {
      try {
        this.showMessage('info', '', 'הקובץ יהיה מוכן בעוד מספר שניות');
        this.dataService.getDownloadFile(fileName, MISPAR_ZIHUY_MAASIK).subscribe((result: any) => {
          window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, fileName);
          }
          let url = window.URL.createObjectURL(result)
          let link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}`;
          link.click();
          setTimeout(() => {
            this.showMessage('success', '', 'הקובץ נשמר בהצלחה');
          }, 1000);
        }, (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בהורדת הקובץ');
        });
      } catch (error) {
        this.showMessage('error', '', 'תקלה בהורדת הקובץ');
      }
    } else {
      this.showMessage('error', '', 'לא נבחר קובץ');
    }
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/file-status/file-status.component.ts